<div class="uploadWrapper">
    <input
        type="file"
        hidden
        accept="{{ settings.accept }}"
        id="upload-{{ guid }}"
        [multiple]="settings.allowMultiple"
        (change)="selectFiles($event)"
        #attachments
    />
    @if (fileUrls && fileUrls.length) {
        @for (url of $any(fileUrls); track url; let index = $index) {
            <div class="fileWrapper" [ngClass]="{ withBorder: !(isOutsideFile && configuration?.disableDeleteButtonOnEdit) }">
                @if (settings.fileType === 'image') {
                    @if (settings.fileType === 'image') {
                        <img class="logo" [alt]="documentFileNames[index]" [src]="url" />
                    }
                    @if (!(!(files[index] && files[index].name) && configuration?.suppressFileNameOnEdit)) {
                        <a class="fileLabel" target="_blank" [href]="url">{{ documentFileNames[index] }}</a>
                    }
                } @else {
                    <i class="far fa-file"></i>
                    <a class="fileLabel" target="_blank" [href]="url">{{ documentFileNames[index] }}</a>
                }
                @if (!(isOutsideFile && configuration?.disableDeleteButtonOnEdit)) {
                    <span class="deleteFile" (click)="clearInput(index)">Delete</span>
                }
            </div>
        }
    } @else {
        <div class="upload">
            <label class="button" for="upload-{{ guid }}">
                <i class="fal fa-upload"></i>
                <span>
                    {{
                        settings.label
                            ? ('generalKeywords.uploadDocument' | translate: { document: settings.label })
                            : ('generalKeywords.upload' | translate)
                    }}
                </span>
            </label>
        </div>
    }
</div>
